module.exports = __webpack_public_path__ + "img/parter-work0.3343147d.png";